<template>
    <b-button
        :type="btnType"
        :variant="btnVariant"
        :class="cssClass"
        @click="onClickButton"
    >
        <span v-if="btnIcon != null" class="btn-icon"
            ><i :class="btnIcon"></i
        ></span>
        <span class="btn-text">{{ btnLabel }}</span>
        <span class="loader"></span>
    </b-button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {},
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        btnType: {
            type: String,
            default: 'Submit',
        },
        btnVariant: {
            type: String,
            default: 'primary',
        },
        cssClass: {
            type: String,
        },
        btnLabel: {
            type: String,
        },
        btnIcon: {
            type: String,
            default: null,
        },
    }, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {}
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {}, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        onClickButton() {
            this.$emit('onClickButton', '')
        },
    }, // End of Component > mounted
} // End of export default
</script>
